import { loadRuntimeConfig } from "plugins/config-loader";
/*
 * Runtime configuration is fetched as JSON before the application is loaded,
 * because modules such as plugins/oidc read it while they are evaluated.
 */
loadRuntimeConfig()
    .catch(() => undefined)
    .then(() => import("./bootstrap"));
